// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExcelFileIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ExcelFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.21 10.56c-.02-.12-.06-.24-.12-.35v-.08c-.06-.11-.13-.21-.22-.3l-7.55-7.49c-.08-.09-.18-.16-.28-.22h-.09a2 2 0 0 0-.33-.12H8.99C6.68 2 4.81 3.86 4.78 6.17v20.09c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.55Zm-2.84 15.7c0 .77-.76.97-1.4.97H8.99c-.64 0-1.4-.17-1.4-.97V6.17c0-.77.63-1.4 1.4-1.4h7.94v5.14a2.35 2.35 0 0 0 2.34 2.34h5.1v14.02Zm-6.1-11.82-2.1 3.86-2-3.86h-2.45l3 5.12-3.28 5.16h2.44l2.16-4.04 2.17 4.04h2.42l-3.23-5.14 3.15-5.14h-2.29Z"
    })
  });
};